import { Component, OnInit, NgZone, ChangeDetectorRef, Input } from '@angular/core';

@Component({
  selector: 'app-loading-wheel',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  // inputs
})


export class LoadingComponent implements OnInit {
  @Input() value: String = 'Loading';
  public message: String;
  constructor(private zone: NgZone, private ref: ChangeDetectorRef) {
  }
  ngOnInit() {
    this.message = this.value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/loading/loading.component.ts